import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import Boton from '../eventos/navegacion_y_accion/Boton';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { IdCard, Building2, LockKeyhole, Copy, MapPin, ShieldCheck, AlertTriangle } from 'lucide-react';
import ImagenDefault from './../../img/imgDefault.png';
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { handleChangeErrors, handleSubmitErrorsPersonas, todosDatosCorrectos } from '../../validacion/ValidationFormPersona';
import { fetchGetPerfil, fetchModificarPerfil, fetch2FAStatus, fetchSetup2FA, fetchVerifySetup2FA, fetchDisable2FA, fetchRegenerateBackupCodes } from '../../../peticiones_API/PeticionesAuth';
import { consumirDestinoTras2FA } from '../../../funciones/rutaRetorno';
import Swal from 'sweetalert2';
import { DatosCorrectosPerfil, DatosIncorrectos } from '../eventos/avisos/VentanaEmergente';

import ErrorForm from '../eventos/avisos/Alerta';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import IconButton from '@mui/material/IconButton';
import { ToastContainer, toast } from 'react-toastify';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import { CircularProgress } from '@mui/material';
import { Button } from 'react-bootstrap';
import OTPInput from '../basicos/OTPInput';
const GEOAPI_KEY = process.env.REACT_APP_GEOAPIFY_API_KEY;

const validarContrasena = (contrasena) => {
    const longitudMinima = contrasena.length >= 8;
    const tieneMayuscula = /[A-Z]/.test(contrasena);
    const tieneMinuscula = /[a-z]/.test(contrasena);
    const tieneNumero = /[0-9]/.test(contrasena);
    const tieneCaracterEspecial = /[!@#$%^&*(),.?":{}|<>]/.test(contrasena);

    return {
        longitudMinima,
        tieneMayuscula,
        tieneMinuscula,
        tieneNumero,
        tieneCaracterEspecial
    };
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ pt: 3 }}>
            {children}
          </Box>
        )}
      </div>
    );
}

const FormEditarPerfil = () => {
    const { Id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    const parametrosBusqueda = new URLSearchParams(location.search);
    const tabDesdeURL = parametrosBusqueda.get('tab');

    const [personaData, setPersonaData] = useState({
        id: Id,
    });
    const [previsualizacionImg, setPrevisualizacionImg] = useState(null);
    const [formCompletado, setFormCompletado] = useState(null);
    const [estadosActualizados, setEstadosActualizados] = useState(false);
    const [avisado, setAvisado] = useState(false);
    const [loading, setLoading] = useState(true);
    const [filas, setFilas] = useState([]);
    const [tabValue, setTabValue] = useState(() => {
        return tabDesdeURL ? parseInt(tabDesdeURL, 10) : 0;
    });
    const [abrirModalMapa, setAbrirModalMapa] = useState(false);
    const [oficinaSeleccionadaMapa, setOficinaSeleccionadaMapa] = useState(null);
    const [coordenadas, setCoordenadas] = useState(null);
    const [loadingMap, setLoadingMap] = useState(false);

    // Estados 2FA
    const [twoFAEnabled, setTwoFAEnabled] = useState(false);
    const [twoFABackupCodesRemaining, setTwoFABackupCodesRemaining] = useState(0);
    const [twoFASetupData, setTwoFASetupData] = useState(null); // { qrCode, manualKey }
    const [twoFASetupCode, setTwoFASetupCode] = useState("");
    const [twoFALoading, setTwoFALoading] = useState(false);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        const nuevosParametrosBusqueda = new URLSearchParams(location.search);
        nuevosParametrosBusqueda.set('tab', newValue.toString());
        navigate(`${location.pathname}?${nuevosParametrosBusqueda.toString()}`, { replace: true });
    };

    const [passwordIncorrecto, setPasswordIncorrecto] = useState(false);
    const [errorValidacionContrasena, setErrorValidacionContrasena] = useState({
        longitudMinima: false,
        tieneMayuscula: false,
        tieneMinuscula: false,
        tieneNumero: false,
        tieneCaracterEspecial: false
    });
    const [showPassword, setShowPassword] = useState({
        password: false,
        new_password: false,
        confirm_new_password: false
    });

    useEffect(() => {
        const fetchPerfil = async () => {
            try {
                const response = await fetchGetPerfil();
                setPersonaData(response.data);

                if(response.data.foto){
                    const urlPrevisualizacion = `/api/persona/imagen/${response.data.foto}?formato=grande`;
                    setPrevisualizacionImg(`${API_URL}${urlPrevisualizacion}` || null);
                }
                setFilas(response.data.Cargos || []);
            } catch (error) {
                console.error("Error al obtener perfil:", error);
            }finally{
                setLoading(false);
            }
        }
        fetchPerfil();
    }, []);

    useEffect(() => {
        const load2FAStatus = async () => {
            try {
                const response = await fetch2FAStatus();
                if (response?.data) {
                    setTwoFAEnabled(response.data.enabled);
                    setTwoFABackupCodesRemaining(response.data.backupCodesRemaining);
                }
            } catch (error) {
                console.error("Error al obtener estado 2FA:", error);
            }
        };
        load2FAStatus();
    }, []);

    const handleSetup2FA = async () => {
        setTwoFALoading(true);
        try {
            const response = await fetchSetup2FA();
            if (response?.data) {
                setTwoFASetupData(response.data);
                setTwoFASetupCode("");
            }
        } catch (error) {
            toast.error("Error al iniciar configuración 2FA");
        } finally {
            setTwoFALoading(false);
        }
    };

    const handleVerifySetup2FA = async () => {
        if (!twoFASetupCode) {
            toast.error("Introduce el código de verificación");
            return;
        }
        setTwoFALoading(true);
        try {
            const response = await fetchVerifySetup2FA({ totpCode: twoFASetupCode });
            if (response?.data?.success) {
                setTwoFAEnabled(true);
                setTwoFASetupData(null);
                setTwoFASetupCode("");

                const codesHtml = response.data.backupCodes.map(c => `<code style="font-size:14px">${c}</code>`).join('<br/>');
                // Se ESPERA a que lo cierre: los códigos de recuperación son lo único que se
                // enseña una sola vez, y el retorno de abajo navegaría por encima del diálogo.
                await Swal.fire({
                    title: 'Códigos de recuperación',
                    html: `<p style="margin-bottom:10px">Guarda estos códigos en un lugar seguro. Los necesitarás si pierdes acceso a tu aplicación de autenticación.</p><div style="background:#f5f5f5;padding:15px;border-radius:8px;line-height:2">${codesHtml}</div>`,
                    icon: 'success',
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: '#336384',
                    width: 500,
                });

                // Recargar estado
                const statusRes = await fetch2FAStatus();
                if (statusRes?.data) {
                    setTwoFABackupCodesRemaining(statusRes.data.backupCodesRemaining);
                }

                // Fase A1 · volver donde estaba quien vino desde la puerta del segundo factor.
                //
                // AQUÍ y no antes: este punto sólo se alcanza con el 2FA ya activado y
                // verificado. Quien abandone la configuración a medias no consume el destino y
                // se queda donde está — volver a la ficha le dejaría la invitación otra vez
                // delante sin entender por qué.
                //
                // Después del diálogo de los códigos de recuperación, no antes: esos códigos
                // son lo único que se enseña una sola vez.
                const volverA = consumirDestinoTras2FA();
                if (volverA) navigate(volverA);
            }
        } catch (error) {
            toast.error("Código de verificación incorrecto");
        } finally {
            setTwoFALoading(false);
        }
    };

    const handleDisable2FA = async () => {
        const { value: code } = await Swal.fire({
            title: 'Desactivar 2FA',
            text: 'Introduce tu código TOTP o un código de recuperación para confirmar',
            input: 'text',
            inputPlaceholder: 'Código TOTP o de recuperación',
            showCancelButton: true,
            confirmButtonText: 'Desactivar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#d33',
            inputValidator: (value) => {
                if (!value) return 'Debes introducir el código';
            }
        });

        if (code) {
            setTwoFALoading(true);
            try {
                const response = await fetchDisable2FA({ totpCode: code });
                if (response?.data?.success) {
                    setTwoFAEnabled(false);
                    setTwoFABackupCodesRemaining(0);
                    toast.success("2FA desactivado correctamente");
                }
            } catch (error) {
                toast.error("Código incorrecto o error al desactivar");
            } finally {
                setTwoFALoading(false);
            }
        }
    };

    const handleRegenerateBackupCodes = async () => {
        const { value: code } = await Swal.fire({
            title: 'Regenerar códigos de recuperación',
            text: 'Introduce tu código TOTP para confirmar',
            input: 'text',
            inputPlaceholder: 'Código de 6 dígitos',
            showCancelButton: true,
            confirmButtonText: 'Regenerar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#336384',
            inputValidator: (value) => {
                if (!value) return 'Debes introducir el código';
            }
        });

        if (code) {
            setTwoFALoading(true);
            try {
                const response = await fetchRegenerateBackupCodes({ totpCode: code });
                if (response?.data?.success) {
                    const codesHtml = response.data.backupCodes.map(c => `<code style="font-size:14px">${c}</code>`).join('<br/>');
                    Swal.fire({
                        title: 'Nuevos códigos de recuperación',
                        html: `<p style="margin-bottom:10px">Los códigos anteriores han sido invalidados. Guarda estos nuevos códigos en un lugar seguro.</p><div style="background:#f5f5f5;padding:15px;border-radius:8px;line-height:2">${codesHtml}</div>`,
                        icon: 'success',
                        confirmButtonText: 'Entendido',
                        confirmButtonColor: '#336384',
                        width: 500,
                    });

                    const statusRes = await fetch2FAStatus();
                    if (statusRes?.data) {
                        setTwoFABackupCodesRemaining(statusRes.data.backupCodesRemaining);
                    }
                }
            } catch (error) {
                toast.error("Código incorrecto o error al regenerar");
            } finally {
                setTwoFALoading(false);
            }
        }
    };

    useEffect(() => {
        const fetchCoordenadas = async () => {
            if (!oficinaSeleccionadaMapa) return;

            setLoadingMap(true);
            setCoordenadas(null);

            const query = `${oficinaSeleccionadaMapa.direccion}, ${oficinaSeleccionadaMapa.poblacion}`;
            const url = `https://api.geoapify.com/v1/geocode/search?text=${encodeURIComponent(query)}&apiKey=${GEOAPI_KEY}&limit=1`;

            try {
                const response = await fetch(url);
                const data = await response.json();

                if (data && data.features && data.features.length > 0) {
                    const lon = data.features[0].geometry.coordinates[0];
                    const lat = data.features[0].geometry.coordinates[1];
                    setCoordenadas({ lat, lon });
                } else {
                    console.warn("No se encontraron coordenadas para la dirección:", query);
                }
            } catch (error) {
                console.error("Error fetching coordinates:", error);
            } finally {
                setLoadingMap(false);
            }
        };

        fetchCoordenadas();
    }, [oficinaSeleccionadaMapa]);

    const handleOpenModalMapa = (oficina) => {
        setOficinaSeleccionadaMapa(oficina);
        setAbrirModalMapa(true);
    };

    const handleCloseModalMapa = () => {
        setAbrirModalMapa(false);
        setOficinaSeleccionadaMapa(null);
        setCoordenadas(null);
    };

    const obtenerDireccionEnvio = () => {
        if (personaData.direccion_envio === 'personal' || !personaData.direccion_envio) {
            if (!personaData.direccion) return null;
            return {
                nombre: 'Dirección Personal',
                direccion: personaData.direccion,
                poblacion: personaData.poblacion || ''
            };
        } else if (personaData.direccion_envio?.startsWith('oficina-')) {
            const oficinaId = parseInt(personaData.direccion_envio.split('-')[1]);
            const oficina = personaData.Oficinas?.find(o => o.Id === oficinaId);
            if (!oficina || !oficina.direccion) return null;
            return {
                nombre: oficina.nombre,
                direccion: oficina.direccion,
                poblacion: oficina.poblacion || ''
            };
        } else if (personaData.direccion_envio) {
            return {
                nombre: 'Dirección Personalizada',
                direccion: personaData.direccion_envio,
                poblacion: ''
            };
        }
        return null;
    };

    const handleOpenMapaDireccionEnvio = () => {
        const direccion = obtenerDireccionEnvio();
        if (direccion) {
            handleOpenModalMapa(direccion);
        }
    };

    const camposRequeridos = {
        password: "Debes insertar tu contraseña actual",
        new_password: "Debes insertar tu nueva contraseña",
        confirm_new_password: "Por favor, repite tu nueva contraseña",
    };

    const [estadoCampoReque, setEstadoCampoReque] = useState({
        password: null,
        new_password: null,
        confirm_new_password: null
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        
        let newValue = value;
        
        setPersonaData(prevPersonaData => ({ ...prevPersonaData, [name]: newValue }));
        
        if (name in estadoCampoReque) {
            handleChangeErrors(name, value, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
        }

        if (name === 'new_password') {
            const validacion = validarContrasena(value);
            setErrorValidacionContrasena(validacion);
        }
    };

    const handleTogglePassword = (field) => {
        setShowPassword(prevState => ({
            ...prevState,
            [field]: !prevState[field]
        }));
    };

    const handleSubmit = async (event) => { 
        event.preventDefault();
        
        setAvisado(false);
        setEstadosActualizados(false);

        if (personaData.new_password) {
            const validacion = validarContrasena(personaData.new_password);
            setErrorValidacionContrasena(validacion);

            if (!Object.values(validacion).every(Boolean)) {
                toast.error("La contraseña no cumple con los requisitos");
                return;
            }
        }

        if (personaData.new_password !== personaData.confirm_new_password) {
            toast.error("Las contraseñas no coinciden");
            return;
        }

        handleSubmitErrorsPersonas(personaData, estadoCampoReque, setEstadoCampoReque, camposRequeridos, setEstadosActualizados);
        let validacionTodosDatos = todosDatosCorrectos(personaData, estadoCampoReque);
        let todosCamposFalse = validacionTodosDatos.todosCamposFalse();
    };

    useEffect(() => {
        if (estadosActualizados) {
            let validacionTodosDatos = todosDatosCorrectos(personaData, estadoCampoReque);
            let todosCamposFalse = validacionTodosDatos.todosCamposFalse();
            (async () => {
                if (todosCamposFalse === true) {
                    setFormCompletado(true);
                    setPasswordIncorrecto(false);
                    try {    
                        const response = await fetchModificarPerfil(personaData);
                        console.log("Persona editada:", response);
                    } catch (error) {
                        if(error?.response?.data?.message === 'La contraseña actual es incorrecta'){
                            setPasswordIncorrecto(true);
                            toast.error("Las contraseña actual es incorrecta");
                        }

                        setFormCompletado(false);
                        console.error("Error al editar perfil:", error);
                    }
                } else {
                    if(!avisado){
                        toast.error("Faltan campos por rellenar");
                        setAvisado(true);
                    }
                }
            })();
        }
    }, [estadosActualizados, personaData, estadoCampoReque]);

    if(loading) return <p>Cargando...</p>;

    return (
        <>
            <Form>
                <Container>
                    <ToastContainer/>
                    <Row>
                        <Col md={12} className="text-end mb-4">
                            <ProfileImage 
                                src={previsualizacionImg || ImagenDefault} 
                                alt="Foto de perfil"
                                onError={(e) => {e.target.src = ImagenDefault}} 
                            />
                        </Col>
                    </Row>

                    {/* Tabs de navegación */}
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={tabValue} onChange={handleTabChange} aria-label="Pestañas de formulario" left>
                            <Tab 
                                label="PERSONAL" 
                                icon={<IdCard size={20} />} 
                            />
                            <Tab 
                                label={personaData.empresaColaboradora ? "EMPRESA" : "NEGOCIO"}
                                icon={<Building2 size={20} />} 
                            />
                            <Tab
                                label="CONTRASEÑA Y SEGURIDAD"
                                icon={<LockKeyhole  size={20} />}
                            />
                        </Tabs>
                    </Box>

                    {/* Contenido de la pestaña Datos Personales */}
                    <TabPanel value={tabValue} index={0}>
                        <PersonalDataContainer>
                            <p>
                                <strong>Nombre y Apellidos:</strong> {personaData.nombre} {personaData.apellidos}<br />
                                <strong>DNI:</strong> {personaData.dni}<br />
                                <strong>Fecha de Nacimiento:</strong> {personaData.fecha_nacimiento == null ? <em>No definido</em> : personaData.fecha_nacimiento}<br />
                                <strong>Código Postal:</strong> {personaData.codigo_postal || <i>No definido</i>}<br />
                                <strong>Provincia:</strong> {personaData.provincia || <i>No definido</i>}<br />
                                <strong>Población:</strong> {personaData.poblacion || <i>No definido</i>}<br />
                                <strong>Dirección:</strong> {personaData.direccion || <i>No definido</i>}<br />
                                <strong>Mail Empresa:</strong> {personaData.mail_empresa}<br />
                                <strong>Teléfono Móvil:</strong> {personaData.telefono_empresa || <i>No definido</i>}<br />
                                <strong>Teléfono Fijo:</strong> {personaData.telefono_fijo || <i>No definido</i>}<br />
                                <strong>Extensión:</strong> {personaData.extension_telefono || <i>No definido</i>}<br />
                                <strong>Dirección de Envío:</strong> {
                                    personaData.direccion_envio === 'personal' || !personaData.direccion_envio ? (
                                        personaData.direccion
                                            ? `Dirección personal (${[personaData.direccion, personaData.codigo_postal, personaData.poblacion].filter(Boolean).join(', ')})`
                                            : <i>No definida</i>
                                    ) : personaData.direccion_envio?.startsWith('oficina-') ? (
                                        (() => {
                                            const oficinaId = parseInt(personaData.direccion_envio.split('-')[1]);
                                            const oficina = personaData.Oficinas?.find(o => o.Id === oficinaId);
                                            if (!oficina) return 'Oficina no encontrada';
                                            const direccionOficina = [oficina.direccion, oficina.cp, oficina.poblacion].filter(Boolean).join(', ');
                                            return direccionOficina ? `${oficina.nombre} (${direccionOficina})` : oficina.nombre;
                                        })()
                                    ) : (
                                        `Personalizada (${personaData.direccion_envio})`
                                    )
                                }
                                {obtenerDireccionEnvio() && (
                                    <BotonMapaInline
                                        type="button"
                                        onClick={handleOpenMapaDireccionEnvio}
                                        title="Ver en mapa"
                                    >
                                        <MapPin size={14} />
                                    </BotonMapaInline>
                                )}
                            </p>
                        </PersonalDataContainer>
                    </TabPanel>
                    
                    {/* Contenido de la pestaña Datos Empresa */}
                    <TabPanel value={tabValue} index={1}>
                        <Row>
                            <Col>
                                <TituloSeccion>{personaData.Oficinas && personaData.Oficinas.length === 1 ? 'OFICINA' : 'OFICINAS'}</TituloSeccion>
                                {personaData.Oficinas && personaData.Oficinas.length > 0 ? (
                                    <OficinasList>
                                        {personaData.Oficinas.map((oficina, index) => (
                                            <OficinaCard key={oficina.Id || index}>
                                                <OficinaHeader>
                                                    <OficinaNombre>{oficina.nombre}</OficinaNombre>
                                                    <BotonMapa
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            handleOpenModalMapa(oficina);
                                                        }}
                                                        title="Ver ubicación en mapa"
                                                    >
                                                        <MapPin size={20} />
                                                    </BotonMapa>
                                                </OficinaHeader>
                                                <OficinaDireccion>
                                                    {oficina.direccion}
                                                    {oficina.cp && `, ${oficina.cp}`}
                                                    {oficina.poblacion && ` - ${oficina.poblacion}`}
                                                </OficinaDireccion>
                                                {oficina.telefono && (
                                                    <OficinaInfo>
                                                        <strong>Tel:</strong> {oficina.telefono}
                                                    </OficinaInfo>
                                                )}
                                                {oficina.mail && (
                                                    <OficinaInfo>
                                                        <strong>Email:</strong> {oficina.mail}
                                                    </OficinaInfo>
                                                )}
                                            </OficinaCard>
                                        ))}
                                    </OficinasList>
                                ) : (
                                    <div className="text-center my-3 text-muted">
                                        No hay oficinas asignadas
                                    </div>
                                )}
                            </Col>
                        </Row>
                        <br></br>
                        {personaData.empresaColaboradora ? (
                            <>
                                <TituloSeccion>EMPRESAS</TituloSeccion>
                                <Row className="align-items-center mb-3">
                                    <Col>
                                        <Form.Group>
                                            <Form.Control
                                                type="text"
                                                disabled
                                                value={personaData.empresaColaboradora.nombre}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </>
                        ) : (
                        <>
                        <TituloSeccion>{filas.length === 1 ? 'CARGO' : 'CARGOS'}</TituloSeccion>
                        <Row>
                            {filas.length === 0 ? (
                                <div className="text-center my-3 text-muted">
                                    No hay cargos asignados
                                </div>
                            ) : (
                                filas.map((fila, index) => (
                                    <Row key={index} className="align-items-center mb-3">
                                        <Col>
                                            <Form.Group>
                                                <TituloCategoria>Negocio</TituloCategoria>
                                                <Form.Select
                                                    value={fila.Negocio.Id}
                                                    disabled="true"
                                                >
                                                    <option value={fila.Negocio.Id}>{fila.Negocio.nombre}</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        {fila.Departamento && (
                                        <Col>
                                            <Form.Group>
                                                <TituloCategoria>Departamento</TituloCategoria>
                                                <Form.Select
                                                    value={fila.Departamento.Id}
                                                    disabled="true"
                                                    readOnly={true}
                                                >
                                                    <option value={fila.Departamento.Id}>{fila.Departamento.nombre}</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        )}

                                        <Col>
                                            <Form.Group>
                                                <TituloCategoria>Cargo</TituloCategoria>
                                                <Form.Control
                                                    type="text"
                                                    disabled="true"
                                                    value={fila.cargo}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                ))
                            )}
                        </Row>
                        </>
                        )}
                    </TabPanel>

                    {/* Contenido de la pestaña Contraseña y Seguridad */}
                    <TabPanel value={tabValue} index={2}>

                        {/* Fase 13 · aquí estaba el aviso de «tu rol requiere activar el 2FA».
                            Ya no: el segundo factor no se exige al entrar, se exige en las puertas.
                            Configurarlo sigue siendo lo que da acceso a Soporte, RRHH y las
                            contraseñas — y ése es el incentivo, no una pantalla que no deja salir. */}

                        {/* Sección Cambiar Contraseña */}
                        <TituloSeccion>Cambiar contraseña</TituloSeccion>
                        <Row md="3">
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <TituloCategoria>Contraseña Actual<span>*</span></TituloCategoria>
                                    <div className="d-flex align-items-center">
                                        <Form.Control type={showPassword.password ? "text" : "password"}  name="password" value={personaData.password || ''} onChange={handleChange} />
                                        <IconButton onClick={() => handleTogglePassword("password")}>
                                            {showPassword.password ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </div>
                                    <ErrorForm mensaje={camposRequeridos.password} estadoAlerta={estadoCampoReque.password} />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <TituloCategoria>Nueva Contraseña<span>*</span></TituloCategoria>
                                    <div className="d-flex align-items-center">
                                        <Form.Control type={showPassword.new_password ? "text" : "password"} name="new_password" value={personaData.new_password || ''} onChange={handleChange} />
                                        <IconButton onClick={() => handleTogglePassword("new_password")}>
                                            {showPassword.new_password ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </div>
                                    <ErrorForm mensaje={camposRequeridos.new_password} estadoAlerta={estadoCampoReque.new_password} />
                                        {personaData.new_password && (
                                            <div className="password-requirements">
                                                <small>Requisitos de contraseña:</small>
                                                <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
                                                    <li style={{ color: errorValidacionContrasena.longitudMinima ? 'green' : 'red' }}>
                                                        {errorValidacionContrasena.longitudMinima ? '✓' : '✗'} Mínimo 8 caracteres
                                                    </li>
                                                    <li style={{ color: errorValidacionContrasena.tieneMayuscula ? 'green' : 'red' }}>
                                                        {errorValidacionContrasena.tieneMayuscula ? '✓' : '✗'} Al menos una mayúscula
                                                    </li>
                                                    <li style={{ color: errorValidacionContrasena.tieneMinuscula ? 'green' : 'red' }}>
                                                        {errorValidacionContrasena.tieneMinuscula ? '✓' : '✗'} Al menos una minúscula
                                                    </li>
                                                    <li style={{ color: errorValidacionContrasena.tieneNumero ? 'green' : 'red' }}>
                                                        {errorValidacionContrasena.tieneNumero ? '✓' : '✗'} Al menos un número
                                                    </li>
                                                    <li style={{ color: errorValidacionContrasena.tieneCaracterEspecial ? 'green' : 'red' }}>
                                                        {errorValidacionContrasena.tieneCaracterEspecial ? '✓' : '✗'} Al menos un carácter especial
                                                    </li>
                                                </ul>
                                            </div>
                                        )}
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <TituloCategoria>Confirmar Nueva Contraseña<span>*</span></TituloCategoria>
                                    <div className="d-flex align-items-center">
                                        <Form.Control type={showPassword.confirm_new_password ? "text" : "password"} name="confirm_new_password" value={personaData.confirm_new_password || ''} onChange={handleChange} />
                                        <IconButton onClick={() => handleTogglePassword("confirm_new_password")}>
                                            {showPassword.confirm_new_password ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </div>
                                    <ErrorForm mensaje={camposRequeridos.confirm_new_password} estadoAlerta={estadoCampoReque.confirm_new_password} />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mt-2">
                            <Col className="text-center">
                                <Boton
                                    bonificados="true"
                                    grande="true"
                                    primario="true"
                                    type="submit"
                                    onClick={handleSubmit}
                                >
                                    Guardar Cambios
                                </Boton>
                                <Boton
                                    grande="true"
                                    to="/panel-inicio"
                                    className="ml-3"
                                >
                                    Cancelar
                                </Boton>
                            </Col>
                        </Row>

                        {/* Sección 2FA */}
                        <div style={{ marginTop: '40px' }}>
                            <TituloSeccion>Autenticación en dos pasos (2FA)</TituloSeccion>

                            {!twoFAEnabled && !twoFASetupData && (
                                <SecurityContainer>
                                    <p style={{ color: '#555', marginBottom: '20px' }}>
                                        La autenticación en dos pasos añade una capa extra de seguridad a tu cuenta.
                                        Al activarla, necesitarás un código de tu aplicación de autenticación (Google Authenticator, Authy, Microsoft Authenticator)
                                        además de tu contraseña para iniciar sesión.
                                    </p>
                                    <Button
                                        style={{ backgroundColor: '#336384', borderColor: '#336384', color: 'white' }}
                                        onClick={handleSetup2FA}
                                        disabled={twoFALoading}
                                    >
                                        {twoFALoading ? <CircularProgress size={20} style={{ color: 'white' }} /> : 'Activar autenticación en dos pasos'}
                                    </Button>
                                </SecurityContainer>
                            )}

                            {!twoFAEnabled && twoFASetupData && (
                                <SecurityContainer>
                                    <p style={{ color: '#555', marginBottom: '15px' }}>
                                        Escanea el código QR con tu aplicación de autenticación, o introduce la clave manual.
                                    </p>
                                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                                        <img src={twoFASetupData.qrCode} alt="Código QR para 2FA" style={{ maxWidth: '200px' }} />
                                    </div>
                                    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                        <small style={{ color: '#888' }}>Clave manual:</small><br />
                                        <code style={{ fontSize: '14px', backgroundColor: '#f5f5f5', padding: '5px 10px', borderRadius: '4px' }}>
                                            {twoFASetupData.manualKey}
                                        </code>
                                    </div>
                                    <Row className="justify-content-center">
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <TituloCategoria style={{ textAlign: 'center', display: 'block' }}>Código de verificación</TituloCategoria>
                                                <div style={{ marginTop: '8px' }}>
                                                    <OTPInput
                                                        value={twoFASetupCode}
                                                        onChange={setTwoFASetupCode}
                                                        autoFocus
                                                    />
                                                </div>
                                            </Form.Group>
                                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                                                <Button
                                                    style={{ backgroundColor: '#336384', borderColor: '#336384', color: 'white' }}
                                                    onClick={handleVerifySetup2FA}
                                                    disabled={twoFALoading}
                                                >
                                                    {twoFALoading ? <CircularProgress size={20} style={{ color: 'white' }} /> : 'Verificar y Activar'}
                                                </Button>
                                                <Button
                                                    variant="outline-secondary"
                                                    onClick={() => { setTwoFASetupData(null); setTwoFASetupCode(""); }}
                                                >
                                                    Cancelar
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </SecurityContainer>
                            )}

                            {twoFAEnabled && (
                                <SecurityContainer>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                                        <ShieldCheck size={24} color="#28a745" />
                                        <span style={{ color: '#28a745', fontWeight: 'bold', fontSize: '16px' }}>
                                            Autenticación en dos pasos activada
                                        </span>
                                    </div>
                                    <p style={{ color: '#555', marginBottom: '15px' }}>
                                        Códigos de recuperación restantes: <strong>{twoFABackupCodesRemaining}</strong> de 10
                                    </p>
                                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                        <Button
                                            style={{ backgroundColor: '#336384', borderColor: '#336384', color: 'white' }}
                                            onClick={handleRegenerateBackupCodes}
                                            disabled={twoFALoading}
                                        >
                                            {twoFALoading ? <CircularProgress size={20} style={{ color: 'white' }} /> : 'Regenerar códigos de recuperación'}
                                        </Button>
                                        <Button
                                            variant="outline-danger"
                                            onClick={handleDisable2FA}
                                            disabled={twoFALoading}
                                        >
                                            Desactivar 2FA
                                        </Button>
                                    </div>
                                </SecurityContainer>
                            )}
                        </div>
                    </TabPanel>

                </Container>
            </Form>

            <DatosCorrectosPerfil envioActivado={formCompletado} />
            <DatosIncorrectos envioActivado={formCompletado} passwordIncorrecto={passwordIncorrecto}/>

            {/* Modal del Mapa */}
            <Dialog
                open={abrirModalMapa}
                onClose={handleCloseModalMapa}
                maxWidth="md"
                fullWidth
            >
                {oficinaSeleccionadaMapa && (
                    <>
                        <DialogTitle sx={{ m: 0, p: 2, bgcolor: '#336384', color: 'white' }}>
                            Ubicación de {oficinaSeleccionadaMapa.nombre}
                            <IconButton
                                aria-label="close"
                                onClick={handleCloseModalMapa}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: 'white',
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                            {loadingMap && (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400 }}>
                                    <CircularProgress />
                                </Box>
                            )}
                            {!loadingMap && coordenadas && (
                                <iframe
                                    width="100%"
                                    height="400"
                                    frameBorder="0"
                                    scrolling="no"
                                    src={`https://www.openstreetmap.org/export/embed.html?bbox=${coordenadas.lon - 0.001},${coordenadas.lat - 0.001},${coordenadas.lon + 0.001},${coordenadas.lat + 0.001}&layer=mapnik&marker=${coordenadas.lat},${coordenadas.lon}`}
                                    style={{ border: '1px solid black' }}
                                    title={`Mapa de ${oficinaSeleccionadaMapa.nombre}`}
                                ></iframe>
                            )}
                            {!loadingMap && !coordenadas && (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400, border: '1px solid #ccc', borderRadius: '4px' }}>
                                    <p style={{ color: '#666' }}>Mapa no disponible</p>
                                </Box>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                style={{
                                    backgroundColor: "rgb(51,99,132)",
                                    borderColor: "rgb(51,99,132)",
                                    color: "white"
                                }}
                                onClick={handleCloseModalMapa}
                            >
                                Cerrar
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>
        </>
    );
}

const ProfileImage = styled.img`
    width: 200px;
    height: 200px;
    object-fit: cover;
    border: 2px solid rgba(0, 60, 102, 0.8);
`;

const PersonalDataContainer = styled.div`
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
    
    p {
        margin: 0;
        line-height: 1.6;
    }
`;

const TituloCategoria = styled(Form.Label)`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 15.6px;
    line-height: 1.8;
    color: #4a4a4a;

    span {
        color: #ff0000;
        font-weight: 400;
        margin-left: 5px;
    }
`;

const ContenedorPassword = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const BotonCopiar = styled.div`
    background-color: ${props => props.$disabled ? '#ccc' : 'rgba(0, 60, 102, 0.8)'};
    border: none;
    border-radius: 4px;
    color: ${props => props.$disabled ? '#666' : 'white'};
    padding: 8px 12px;
    cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
    display: flex;
    align-items: center;
    transition: background-color 0.2s;
    opacity: ${props => props.$disabled ? 0.6 : 1};

    &:hover {
        background-color: ${props => props.$disabled ? '#ccc' : 'rgba(0, 60, 102, 1)'};
    }
`;

const TituloSeccion = styled.h5`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 18px;
    margin-top: 0;
    margin-bottom: 20px;
    color: #2c3e50;
    border-bottom: 2px solid lightgrey;
    padding-bottom: 8px;
`;

const OficinasList = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
`;

const OficinaCard = styled.div`
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 20px;
    transition: box-shadow 0.2s;

    &:hover {
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
`;

const OficinaHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
`;

const OficinaNombre = styled.h6`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 16px;
    color: rgba(0, 60, 102, 0.9);
    margin: 0;
`;

const BotonMapa = styled.button`
    background-color: rgba(0, 60, 102, 0.8);
    border: none;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    cursor: pointer;
    transition: all 0.2s;
    padding: 0;

    &:hover {
        background-color: rgba(0, 60, 102, 1);
        transform: scale(1.1);
    }

    &:active {
        transform: scale(0.95);
    }
`;

const OficinaDireccion = styled.p`
    color: #4a4a4a;
    font-size: 14px;
    margin-bottom: 10px;
    line-height: 1.5;
`;

const OficinaInfo = styled.p`
    color: #6c757d;
    font-size: 13px;
    margin-bottom: 5px;

    strong {
        color: #4a4a4a;
    }
`;

const SecurityContainer = styled.div`
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 25px;
    margin-bottom: 20px;
`;

const Force2FABanner = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    background-color: #fff3cd;
    border: 1px solid #ffc107;
    border-radius: 8px;
    padding: 15px 20px;
    margin-bottom: 25px;
    color: #856404;
    font-weight: 500;
    font-size: 14px;
`;

const BotonMapaInline = styled.button`
    background-color: rgba(0, 60, 102, 0.8);
    border: none;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: white;
    cursor: pointer;
    transition: all 0.2s;
    padding: 0;
    margin-left: 8px;
    vertical-align: middle;

    &:hover {
        background-color: rgba(0, 60, 102, 1);
        transform: scale(1.1);
    }

    &:active {
        transform: scale(0.95);
    }
`;

export default FormEditarPerfil;